import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export interface BreadcrumbItem {
  label: string;
  view: string;
  icon?: React.ElementType;
}
interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  currentView: string;
  setCurrentView: (view: string) => void;
}
export function Breadcrumbs({
  items,
  currentView,
  setCurrentView
}: BreadcrumbsProps) {
  return <nav className="bg-gray-50 py-2 px-4 sm:px-6 lg:px-8 border-b border-gray-200" aria-label="Breadcrumb" data-id="element-1977">
      <ol className="max-w-full flex items-center space-x-1 md:space-x-3" data-id="element-1978">
        {items.map((item, index) => <li key={index} className="inline-flex items-center" data-id="element-1979">
            {index > 0 && <ChevronRightIcon className="w-4 h-4 text-gray-400 mx-1" data-id="element-1980" />}
            {index < items.length - 1 ? <button onClick={() => setCurrentView(item.view)} className="inline-flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-800" data-id="element-1981">
                {item.icon && <item.icon className="w-4 h-4 mr-2" data-id="element-1982" />}
                {item.label}
              </button> : <span className="text-sm font-medium text-gray-500 flex items-center" data-id="element-1983">
                {item.icon && <item.icon className="w-4 h-4 mr-2" data-id="element-1984" />}
                {item.label}
              </span>}
          </li>)}
      </ol>
    </nav>;
}